import { render, staticRenderFns } from "./DetailEventChartPanel.vue?vue&type=template&id=2b6717be&scoped=true&"
import script from "./DetailEventChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailEventChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailEventChartPanel.vue?vue&type=style&index=0&id=2b6717be&lang=scss&scoped=true&"
import style1 from "./DetailEventChartPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6717be",
  null
  
)

export default component.exports